import store from '@/store';
import { i18n } from '@/lang';
import { guardRoute } from '@/router';
import {
    ROUTES_ADD_RESULTS,
    ROUTES_SESSION_ATTENDANCE,
    ROUTES_SESSION_CREWS,
    ROUTES_SESSION_IMPORTS,
    ROUTES_SESSION_IMPORT_FILE,
    ROUTES_SESSION_OVERVIEW,
    ROUTES_SESSION_RESULTS,
    ROUTES_SESSION_TELEMETRY,
    ROUTES_SESSION_RESULTS_LIVE,
    ROUTES_SWITCH_CLUB
} from '@/constants/routes';

export default {
    path: '/session',
    name: 'session',
    component: () => import(/*webpackChunkName: 'session'*/ '@/views/Session'),
    redirect: { name: ROUTES_SESSION_OVERVIEW },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/session/:sessionId',
            name: ROUTES_SESSION_OVERVIEW,
            beforeEnter: guardRouteSession,
            component: () => import(/*webpackChunkName: 'session'*/ '@/components/session/overview/SessionOverview')
        },
        {
            path: '/session/:sessionId/attendance',
            name: ROUTES_SESSION_ATTENDANCE,
            beforeEnter: guardRouteSession,
            component: () => import(/*webpackChunkName: 'session'*/ '@/components/session/attendance/Attendance')
        },
        {
            path: '/session/:sessionId/crews',
            name: ROUTES_SESSION_CREWS,
            beforeEnter: guardRouteSession,
            component: () => import(/*webpackChunkName: 'session'*/ '@/components/session/crews/SessionCrews'),
            props: true
        },
        {
            path: '/session/:sessionId/results',
            name: ROUTES_SESSION_RESULTS,
            meta: {
                requiresSpeedIntensities: true,
                requiresStrokeRateIntensitiesRowing: true,
                requiresStrokeRateIntensitiesPaddling: true
            },
            beforeEnter: guardRouteSession,
            component: () =>
                import(/*webpackChunkName: 'session-results'*/ '@/components/session/results/SessionResults')
        },
        {
            path: '/session/:sessionId/telemetry',
            name: ROUTES_SESSION_TELEMETRY,
            meta: {
                requiresSpeedIntensities: true,
                requiresStrokeRateIntensitiesRowing: true,
                requiresStrokeRateIntensitiesPaddling: true
            },
            beforeEnter: guardRouteSession,
            component: () => import(/*webpackChunkName: 'session-results'*/ '@/components/session/telemetry/Telemetry')
        },
        {
            path: '/session/:sessionId/live-results',
            name: ROUTES_SESSION_RESULTS_LIVE,
            beforeEnter: guardRouteLiveResults,
            component: () =>
                import(
                    /*webpackChunkName: 'session-live-results'*/ '@/components/session/live-results/SessionLiveResults'
                )
        },
        {
            path: '/session/:sessionId/imports',
            name: ROUTES_SESSION_IMPORTS,
            beforeEnter: guardRouteImports,
            component: () =>
                import(
                    /*webpackChunkName: 'session-file-import'*/ '@/components/session/imports/file-list/SessionImportFile'
                )
        },
        {
            path: '/session/:sessionId/imports/edit/:crewId/:fileId',
            name: ROUTES_SESSION_IMPORT_FILE,
            beforeEnter: guardRouteImports,
            component: () =>
                import(
                    /*webpackChunkName: 'session-file-import'*/ '@/components/session/imports/file-preview/SessionImportFile'
                )
        },
        {
            path: '/session/:sessionId/add-results',
            name: ROUTES_ADD_RESULTS,
            beforeEnter: guardRouteAddResults,
            component: () => import(/*webpackChunkName: 'add-results'*/ '@/components/add-results/AddResults')
        }
    ]
};

function guardRouteSession(to, from, next) {
    checkSession(to, from, next);
}

function guardRouteImports(to, from, next) {
    checkSession(to, from, next);
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureImports'];
    guardRoute(next, false, notInFeatureSet);
}

function guardRouteLiveResults(to, from, next) {
    checkSession(to, from, next);
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureLiveResults'];
    guardRoute(next, false, notInFeatureSet);
}

function guardRouteAddResults(to, from, next) {
    checkSession(to, from, next);
    checkSessionAddResults(to, from, next);
}

function checkSession(to, from, next) {
    store
        .dispatch('sessionDetails/getSessionDetails', {
            id: Number(to.params.sessionId)
        })
        .then(({ data }) => {
            const belongsToAnotherClub = data.club_id !== store.getters.selectedClubId;
            if (belongsToAnotherClub) {
                store.dispatch('notifyError', { message: i18n.t('thisSessionBelongsToAnotherClub') });
                next({ name: ROUTES_SWITCH_CLUB, params: { clubId: data.club_id } });
            } else {
                store.commit('sessionDetails/sessionSave', data);
                store.commit('addResultsImportData/setSession', data);
                guardRoute(next);
            }
        })
        .catch(error => {
            store.dispatch('notifyError', error);
            guardRoute(next, true);
        });
}

function checkSessionAddResults(to, from, next) {
    store
        .dispatch('addResultsMain/getSessionDetails', {
            id: Number(to.params.sessionId)
        })
        .then(({ data }) => {
            const belongsToAnotherClub = data.club_id !== store.getters.selectedClubId;
            if (!belongsToAnotherClub) {
                store.commit('addResultsMain/sessionSave', data);
                store.commit('addResultsAttendance/setStatuses', data);
            }
            guardRoute(next);
        })
        .catch(error => {
            store.dispatch('notifyError', error);
            guardRoute(next, true);
        });
}
